const BASEURL = 'https://raven-apps.s3.amazonaws.com/demodata';

export function fetchDemoCards(demo, ravenUuid) {
    const filename = `cards-${ravenUuid}.json`;
    return fetch(`${BASEURL}/${demo}/${filename}`)
        .then(res => res.json());
}

export function fetchDemoCard(demo, ravenUuid, cardId) {
    const filename = `card-${ravenUuid}-${cardId}.json`;
    return fetch(`${BASEURL}/${demo}/${filename}`)
        .then(res => res.json());
}

export function fetchDemoCardTripReport(demo, ravenUuid, cardId) {
    const filename = `card-tripreport-${ravenUuid}-${cardId}.json`;
    return fetch(`${BASEURL}/${demo}/${filename}`)
        .then(res => res.json())
        .then(json => json.tripReport);
}
